import MicroServicesPage from '../aws/MicroServicesPage';

export default function IdcManagementPage() {
  return MicroServicesPage('aws-customer-portal-idc-management');
}
